import { Auth0Provider } from "@auth0/auth0-react";
import { PropsWithChildren } from "react";

type SharedAuth0ProviderProps = PropsWithChildren<{
  onRedirectCallback?: (appState?: { returnTo?: string }) => void;
}>;

/** Shared Auth0 provider wrapper with repo-standard env wiring. */
export default function SharedAuth0Provider({ children, onRedirectCallback }: SharedAuth0ProviderProps) {
  return (
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN as string}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID as string}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      useRefreshTokens
      authorizationParams={{
        redirect_uri: import.meta.env.VITE_AUTH0_REDIRECT_URI as string,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE as string,
      }}
    >
      {children}
    </Auth0Provider>
  );
}
